import type { IEditorProps } from "@inputs/text/EditorV1";
import { Editor } from "@styleguide";
import { Controller, type FieldPath, type FieldValues, type UseControllerProps } from "react-hook-form";

type TEditorFormProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = UseControllerProps<
  TFieldValues,
  TName
> &
  Omit<IEditorProps, "value" | "plugins" | "toolbar" | "onInit" | "onChange"> &
  Partial<Pick<IEditorProps, "onChange">>;

export const EditorForm = <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  rules,
  shouldUnregister,
  defaultValue,
  onChange,
  ...editorProps
}: TEditorFormProps<TFieldValues, TName>) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      render={({ field: { value, onChange: onChangeForm } }) => (
        <Editor
          {...editorProps}
          value={value}
          onChange={(...args) => {
            if (onChange) {
              onChange(...args);
            }
            onChangeForm(...args);
          }}
        />
      )}
    />
  );
};
